
<template>
  <v-layout column>
    <section :class="$vuetify.breakpoint.name === 'xl' ? 'container' : ''">
      <v-container>
        <v-row justify="center" align="center" :style="token ? 'min-height: 77.6vh;' : 'min-height: 100vh;'">
          <v-col cols="12" md="6">
            <v-card flat class="border-radius pa-12">
              <v-row justify="center" align="center">
                <v-col cols="12" md="10">
                  <div class="mb-12">
                    <v-img 
                      alt="vuetify" 
                      :src="require('@/assets/image/500.png')"
                      max-height="175"
                      max-width="175"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="#388E3C">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <div class="text-center">
                    <p class="title text-first font-weight-bold my-6">
                      Internal server error
                    </p>

                    <p class="body-1 font-weight-light text-second line-text-second pb-12">
                      Tautan yang Anda kunjungi mungkin rusak atau tidak ada lagi.
                    </p>

                    <v-btn
                      light
                      large
                      color="#388E3C"
                      elevation="0"
                      class="body-1 font-weight-bold white--text text-capitalize border-radius"
                      to="/">
                      <v-icon class="mr-2">mdi-chevron-left-circle-outline</v-icon>
                      Kembali Ke Halaman Utama
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-layout>
</template>

<script>
  export default {
    computed: {
      token () {
        return this.$store.state.token
      }
    }
  }
</script>